/*
 * WC-ZOOM-CAPTION.JS  -  a caption on the enlarged product photograph
 * ---------------------------------------------------------------------------
 *
 * Clicking a product photograph opens it in Horizon's zoom dialog, which
 * when-create.css (11.14) turns into a centred card with the thumbnail
 * strip pinned to its bottom edge. The dialog shows the picture and
 * nothing about it. Every photograph here carries alt text written for it
 * ("Cap Hanger by FIX LAYER. 3D printed and made to order in Cyprus.
 * Product slide 6 of 10."), so the words exist; this prints them under the
 * picture, above the thumbnails, for whichever picture is in view. The
 * trailing "Product slide 6 of 10" is dropped: it is for screen readers,
 * not for a caption.
 *
 * HOW IT FINDS THE PICTURE IN VIEW
 * The card scrolls sideways through ul.dialog-zoomed-gallery (11.14 turned
 * the stock column on its side), one li.product-media-container per
 * picture. On open, and on every scroll inside the dialog, the li whose
 * centre is nearest the card's centre is the one in view; its img's alt is
 * the caption. Scroll is listened for in the capture phase on the dialog,
 * so it is caught whichever element inside it actually scrolls.
 *
 * Markup from Horizon 4.2.0's snippets/product-media-gallery-content.liquid:
 * zoom-dialog > dialog.dialog-zoomed-gallery__dialog, holding the close
 * button, div.dialog-thumbnails-list-container and the ul. The caption is
 * one element appended to the dialog, styled in when-create.css (11.21).
 *
 * Deliberately a script rather than an edit to Horizon's snippet: that file
 * is stock Horizon, and this project keeps no copy of stock Horizon.
 * Removing the <script> line in theme.liquid removes the caption.
 */
(function () {
  'use strict';

  var DIALOG = 'zoom-dialog dialog';
  var SLIDE = '.dialog-zoomed-gallery > li';

  function captionText(li) {
    var img = li.querySelector('img');
    var alt = img ? (img.getAttribute('alt') || '') : '';
    return alt.replace(/\s*Product slide \d+ of \d+\.?\s*$/i, '').trim();
  }

  function slideInView(dialog) {
    var slides = dialog.querySelectorAll(SLIDE);
    if (!slides.length) return null;
    var box = dialog.getBoundingClientRect();
    var mid = box.left + box.width / 2;
    var best = null, bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var r = slides[i].getBoundingClientRect();
      if (r.width === 0) continue;             /* display:none, e.g. the hidden 3D model */
      var d = Math.abs(r.left + r.width / 2 - mid);
      if (d < bestDist) { bestDist = d; best = slides[i]; }
    }
    return best;
  }

  function ensureCaption(dialog) {
    var cap = dialog.querySelector('.wc-zoom-caption');
    if (!cap) {
      cap = document.createElement('p');
      cap.className = 'wc-zoom-caption';
      cap.setAttribute('aria-hidden', 'true');   /* the alt text already reaches a screen reader */
      dialog.appendChild(cap);
    }
    return cap;
  }

  function update(dialog) {
    if (!dialog.open) return;
    var li = slideInView(dialog);
    var text = li ? captionText(li) : '';
    var cap = ensureCaption(dialog);
    if (cap.textContent !== text) cap.textContent = text;
    cap.hidden = !text;
    /* Sit the caption just above the thumbnail strip, however tall it is. */
    var thumbs = dialog.querySelector('.dialog-thumbnails-list-container');
    var h = thumbs ? thumbs.getBoundingClientRect().height : 0;
    dialog.style.setProperty('--wc-zoom-thumbs', Math.round(h) + 'px');
  }

  var pending = null;
  function schedule(dialog) {
    if (pending) return;
    pending = requestAnimationFrame(function () {
      pending = null;
      update(dialog);
    });
  }

  function wire(dialog) {
    if (dialog.hasAttribute('data-wc-caption')) return;
    dialog.setAttribute('data-wc-caption', '');
    passTouches(dialog);
    mouseDrag(dialog);
    dialog.addEventListener('scroll', function () { schedule(dialog); }, true);
    new MutationObserver(function () { schedule(dialog); })
      .observe(dialog, { attributes: true, attributeFilter: ['open'] });
    window.addEventListener('resize', function () { schedule(dialog); });
  }

  /* THE DOTS THAT LEAD NOWHERE (20 October 2026). On a phone the gallery
     shows one dot per media item, 3D models included, and 11.13a hides the
     model slides. A dot for a hidden slide asks the slideshow for a slide
     with no width, and it lands on the first picture instead: on Bar Ends
     dots 6 and 7 both showed the hero slide. So the dot of every model
     slide is hidden with it. Slide and dot share an index; the slide
     carries product-media-container--model, the dot is ref="dots[]". */
  function hideModelDots() {
    var galleries = document.querySelectorAll('media-gallery');
    for (var g = 0; g < galleries.length; g++) {
      var slides = galleries[g].querySelectorAll('slideshow-slide');
      if (!slides.length) continue;
      /* Horizon can render two sets of controls, one for desktop and one
         for phones, each with its own dots; every list is matched to the
         slides on its own. */
      var lists = galleries[g].querySelectorAll('.slideshow-controls__dots');
      for (var l = 0; l < lists.length; l++) {
        var dots = lists[l].querySelectorAll('[ref="dots[]"]');
        if (dots.length !== slides.length) continue;
        for (var i = 0; i < slides.length; i++) {
          var isModel = slides[i].classList.contains('product-media-container--model') ||
                        !!slides[i].querySelector('model-viewer, product-model');
          var holder = dots[i].closest('li') || dots[i];
          if (isModel) holder.setAttribute('hidden', '');
        }
      }
    }
  }

  /* SWIPING BETWEEN PICTURES ON A PHONE (20 October 2026). Horizon's
     drag-zoom-wrapper, on phones only, takes every touch on the opened
     picture for itself (preventDefault on touchstart and touchmove) so it
     can drag a picture it has magnified. 11.24 shows the picture whole,
     unmagnified, so that drag has nothing to move, and it would also stop
     the finger from swiping on to the next picture. So on a phone, touches
     inside the opened picture are stopped at the dialog, before they reach
     the wrapper: the gallery then scrolls natively, one picture per swipe.
     The browser's own pinch-zoom of the page still works. */
  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  /* DRAGGING WITH THE MOUSE (20 October 2026). On a desktop the opened
     pictures sit side by side in a row that scrolls, but a mouse cannot
     swipe it, so only the thumbnails moved on. Press, drag sideways and let
     go: the row follows the pointer and settles on the nearest picture.
     Snapping is paused while dragging, or it would fight the pointer. A
     drag of more than a few pixels swallows the click that follows it, so
     letting go never also counts as a click on the picture. Touch and pen
     are left to the browser, which already swipes. */
  function mouseDrag(dialog) {
    dialog.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var row = e.target.closest && e.target.closest('.dialog-zoomed-gallery');
      if (!row || row.scrollWidth <= row.clientWidth) return;
      var startX = e.clientX, startLeft = row.scrollLeft, moved = false;
      var snap = row.style.scrollSnapType;
      function move(ev) {
        var dx = ev.clientX - startX;
        if (!moved && Math.abs(dx) < 6) return;
        if (!moved) { moved = true; row.style.scrollSnapType = 'none'; row.style.cursor = 'grabbing'; }
        row.scrollLeft = startLeft - dx;
        ev.preventDefault();
      }
      function up() {
        document.removeEventListener('pointermove', move);
        document.removeEventListener('pointerup', up);
        if (!moved) return;
        var w = row.clientWidth || 1;
        var target = Math.round(row.scrollLeft / w) * w;
        row.style.cursor = '';
        row.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(function () { row.style.scrollSnapType = snap; }, 400);
        dialog.addEventListener('click', function swallow(ce) {
          ce.stopPropagation(); ce.preventDefault();
        }, { capture: true, once: true });
      }
      document.addEventListener('pointermove', move);
      document.addEventListener('pointerup', up);
      e.preventDefault();   /* no image ghost-drag, no text selection */
    });
  }
  function passTouches(dialog) {
    ['touchstart', 'touchmove', 'touchend'].forEach(function (type) {
      dialog.addEventListener(type, function (e) {
        if (!PHONE || !PHONE.matches) return;
        if (e.target && e.target.closest && e.target.closest('drag-zoom-wrapper')) e.stopPropagation();
      }, { capture: true, passive: true });
    });
  }

  function start() {
    var dialogs = document.querySelectorAll(DIALOG);
    for (var i = 0; i < dialogs.length; i++) wire(dialogs[i]);
    hideModelDots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* Horizon re-renders the gallery when a variant with other pictures is
     chosen; a new dialog element then needs wiring too. */
  new MutationObserver(start).observe(document.body, { childList: true, subtree: true });
})();
